<template>
<div class="chapter">
<div class="inner_page">
<h1>Tabla de Contenido</h1>
<p><span href="#/c001" title="Link target outside of Sample">Título</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Derechos de Autor</span></p>
<p><a href="#/c003">Arthyl, | el Avatar de Eloïr</a></p>
<p><a href="#/c004">Cédric Frantz</a></p>
<p><span href="#/c005" title="Link target outside of Sample">Polen</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Semillas</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Germen</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Flor</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Fruta</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Bahías</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Caduco</span></p>
<p><span href="#/c012" title="Link target outside of Sample">At’Rom</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Manglar</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Florece</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Florades</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Adviento</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?82422e38